module.exports = __webpack_public_path__ + "images/2b96381e08c64dee8b98099333428c2c.png";